<script>
import resourceSelect from '../../mixins/resourceSelect';

export default {
  mixins: [resourceSelect],

  data() {
    return {
      route: 'api.users.index',
      defaults: {
        trackBy: 'id',
        label: 'display_name',
        placeholder: 'Sélectionnez un utilisateur',
      },
    };
  },
};
</script>